<template lang="pug">
.content.exercise-content
  .row.exercise-body
    .col-md-12.col-md-header
      .header Danh sách bài tập
      .box-add-exercise(:style="$isMobile() ? 'float: none; margin-top: 0;' : ''")
        button.btn.btn-exercise-add(@click="onRouteAdd" :style="$isMobile() ? 'margin-bottom: 10px;' : ''") Thêm bài tập
      //- .clearfix
    .col-md-6.select-subject
      .form-group
        label.control-label Chọn môn học muốn xem *
        select#subject-id.form-control(@change="onChangeSubject($event)" required)
          //- option(value='0') Chọn
          option(v-for='o in subjects' :value='o.id') {{o.name}}
      .clearfix
    .col-md-12.col-md-lst-exercise
      .box-table-exercise(v-on:scroll.passive='handleScroll' v-if="!$isMobile()")
        tbExercise(
          @onfilterbyname="filterbyname",
          @onfilterbystatus="filterbystatus",
          @onItemDelete="onExerciseFormDelete",
          @onItemEdit="onExerciseFormEdit",
          @onLockAssistantItem="lockAssistantItem",
          @onFilterBlue="filterBlue",
          :lstStatus='lstStatus',
          :lstLevel='lstLevel',
          :lstTypeTest='lstTypeTest',
          :lstLock='lstLock',
          :lstFilter='lstFilter',
          :data='exercises',
          :columns='columns',
          :inlineFilter='true'
        )
      .card.card-lst-exercise(v-else style="margin-top: 0;border-radius: 10px;")
        //- .card-content.card-content-lst-exercise
          //- div(style='font-weight: bold;') LIST QUESTION PENDDING
        .row-header
          span.label-header 
            span.name Tên bài tập
            span.fas.fa-sort-alpha-down(@click="filterItems(sort, 6)" :class="sort ? 'checked' : ''")
          .field-header
            input(@change="filterbyname($event.target.value)" placeholder="Tìm theo nội dung câu hỏi lớn")
        .row-header.last
          span.label-header Trạng thái
          .field-header
            select(@change="filterbystatusX($event.target.value)")
              option( value='') Tất cả
              option(v-for='(o, i) in lstStatus' :value='o.key') {{o.value}}
        .list-action-all(v-if='exercises.length > 0')
          small(@click="lockAssistantItem({data: null, type: 1})")
            .fas.fa-user-edit
          small(@click="lockAssistantItem({data: null, type: 2})")
            .fas.fa-user-lock
        .clearfix
        .empty-data(v-if='exercises.length === 0') 
          span(style='font-weight:bold;') Không tìm thấy dữ liệu
        .list-item(v-else style="overflow-y: scroll;" v-on:scroll.passive='handleScrollX')
          .row-item(v-for='(item, index) in exercises')
            .row-data
              .board-info
                span {{item.content}}
            .row-data
              span.label-header Trạng thái:
              .row-value(:style="item.is_complete ? 'color:#3A9F00;' : 'color:#D63131;'") {{getDataValue(item.is_complete, 4)}}
            .row-data
              .filter-item
                span(:id="'categ_' + item.category_exercise.id" 
                  @click="filterItems(item.category_exercise.id, 1)"
                  :class="lstFilter.categories.includes(item.category_exercise.id) ? 'checked' : ''"
                ) {{item.category_exercise.name}}
                span(:id="'type_' + item.type_test" 
                  @click="filterItems(item.type_test, 4)"
                  :class="lstFilter.type_exercise.includes(item.type_test) ? 'checked' : ''"
                ) {{getDataValue(item.type_test, 2)}}
                span(:id="'lv_' + item.level" 
                  @click="filterItems(item.level, 2)"
                  :class="lstFilter.level.includes(item.level) ? 'checked' : ''"
                ) {{getDataValue(item.level, 1)}}
                span(:id="'lock_' + item.is_lock" 
                  @click="filterItems(item.is_lock, 5)"
                  :class="lstFilter.lock.includes(item.is_lock) ? 'checked' : ''"
                ) {{getDataValue(item.is_lock, 3)}}
                span(v-for="g in item.exercise_grades" 
                  :id="'grade_' + g.grade.id" 
                  @click="filterItems(g.grade.id, 3)"
                  :class="lstFilter.grades.includes(g.grade.id) ? 'checked' : ''"
                ) {{g.grade.name}}
            .row-data
              .action-buttons
                span.list-action
                  small(@click="collapseLines(item.id, true)" :class="'more-' + item.id")
                    img(:src="require('../../assets/images/theory/ic_moreinformation.svg')")
                  small.hidden(@click="collapseLines(item.id, false)" :class="'less-' + item.id")
                    img(:src="require('../../assets/images/theory/ic_lessinformation.svg')")
                span.list-action
                  small(@click="onExerciseFormEdit(item)")
                    img(:src="require('../../assets/images/faces/ic_edit.svg')")
                span.list-action
                  small(@click="onExerciseFormDelete(item)")
                    img(:src="require('../../assets/images/theory/delete-24px.svg')")
                span.list-action
                  small
                    .fas.fa-user-edit(v-if="!item.is_lock" style="color:#333333;" @click="lockAssistantItem({data: item, type: 3})")
                    .fas.fa-user-lock(v-else style="color:#333333;" @click="lockAssistantItem({data: item, type: 4})")
                span.list-action
                  small.public
                    .material-icons.ic-public public
            .show-more.hidden(:class="'show-more-' + item.id")
              .row-data
                span.label-header Ngày tạo:
                .row-value {{formatDate(item.created_at)}}
              .row-data
                span.label-header Người tạo:
                .row-value {{item.userCreate.fullname}}
              .row-data
                span.label-header Ngày cập nhật:
                .row-value {{formatDate(item.updated_at)}}
              .row-data
                span.label-header Người cập nhật:
                .row-value {{item.userUpdate.fullname}}

</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import tbExercise from './tbExercise'
import popupDeleteExercise from './popupDelete'
import popupLockExercise from './popupLock'
import jQuery from 'jquery'
import moment from 'moment'
export default {
  components: {
    jQuery,
    moment,
    tbExercise,
    popupDeleteExercise,
    popupLockExercise
  },
  data() {
    return {
      offset: 0,
      limit: 10,
      subjects: [],
      exercises: [],
      columns: [
        { key: 'stt', title: 'STT' },
        { key: 'content', title: 'Tên bài tập', type: 'name' },
        { key: 'is_complete', title: 'Trạng thái', type: 'status' },
        { key: 'userCreate', title: 'Người tạo', type: 'created_user' },
        { key: 'created_at', title: 'Ngày tạo', type: 'date' },
        { key: 'userUpdate', title: 'Người cập nhật', type: 'created_user' },
        { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
        { key: 'action', title: '', type: 'action' }
      ],
      lstStatus: [
        {key: true, value: 'Hoàn thành'},
        {key: false, value: 'Chưa hoàn thành'}
      ],
      lstLevel: [
        {key: 1, value: 'Sơ cấp'},
        {key: 2, value: 'Trung cấp'},
        {key: 3, value: 'Cao cấp'}
      ],
      lstTypeTest: [
        {key: 1, name: 'Quiz random'},
        {key: 2, name: 'Bài tập thi đấu'},
        {key: 3, name: 'Khóa học'},
        {key: 4, name: 'Bài tập chung'}
      ],
      lstLock: [
        {key: false, value: 'Chưa khóa'},
        {key: true, value: 'Đã khóa'}
      ],
      filtername: '',
      filterstatus: null,
      filtersubject: null,
      mobile: false,
      lstFilter: {
        categories: [],
        level: [],
        grades: [],
        type_exercise: [],
        lock: [],
        order_by: false
      },
      sort: false
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    onRouteAdd() {
      this.$router.push('/exercise_add')
      // this.showNotification('Đang xây dựng', 'warning', 'top', 'right', 7000)
    },
    getDataValue(key, type) {
      if (type === 1) {
        for (let i = 0; i < this.lstLevel.length; i++) {
          if (this.lstLevel[i].key === key) return this.lstLevel[i].value
        }
      } else if (type === 2) {
        for (let i = 0; i < this.lstTypeTest.length; i++) {
          if (this.lstTypeTest[i].key === key) return this.lstTypeTest[i].name
        }
      } else if (type === 3) {
        for (let i = 0; i < this.lstLock.length; i++) {
          if (this.lstLock[i].key === key) return this.lstLock[i].value
        }
      } else if (type === 4) {
        for (let i = 0; i < this.lstStatus.length; i++) {
          if (this.lstStatus[i].key === key && key) {
            return this.lstStatus[i].value
          } else if (this.lstStatus[i].key === key && !key) {
            return this.lstStatus[i].value
          }
        }
      }
    },
    collapseLines(id, type) {
      if (type) {
        jQuery('.more-' + id).hide()
        jQuery('.less-' + id).show().removeClass('hidden').css('display', 'inline-block')
        // jQuery('.less-' + id)
        jQuery('.show-more-' + id).show().removeClass('hidden')
      } else {
        jQuery('.more-' + id).show()
        jQuery('.less-' + id).hide()
        jQuery('.show-more-' + id).hide()
      }
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm')
    },
    onChangeSubject(e) {
      // console.log(e.target.value)
      let valueSubject = parseInt(e.target.value)
      this.filtersubject = null
      if (valueSubject !== 0) {
        this.filtersubject = valueSubject
      }
      this.$apollo.queries.exercises.refetch()
      // this.refreshExercises()
    },
    getSubjectDefalt() {
      if (this.subjects.length > 0) {
        this.filtersubject = this.subjects[0].id
      }
    },
    handleScroll: function(e) {
      if ((e.target.scrollHeight - 385) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 385) === Math.floor(e.target.scrollTop)) {
        this.limit = this.exercises.length + 10
        // this.refreshExercises()
        this.$apollo.queries.exercises.refetch()
      }
    },
    handleScrollX: function(e) {
      if ((e.target.scrollHeight - 538) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 538) === Math.floor(e.target.scrollTop)) {
        this.limit = this.exercises.length + 5
        // this.refreshExercises()
        this.$apollo.queries.exercises.refetch()
      }
    },
    filterbyname(valueName) {
      // console.log(valueName)
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      this.$apollo.queries.exercises.refetch()
      // this.refreshExercises()
    },
    filterbystatus(valueStatus) {
      this.filterstatus = null
      if (valueStatus === 0) {
        this.filterstatus = false
      } else if (valueStatus === 1) {
        this.filterstatus = true
      } else {
        this.filterstatus = null
      }
      this.$apollo.queries.exercises.refetch()
      // this.refreshExercises()
    },
    filterbystatusX(value) {
      // console.log(value, typeof value)
      this.filterstatus = null
      if (value === 'false') {
        this.filterstatus = false
      } else if (value === 'true') {
        this.filterstatus = true
      } else {
        this.filterstatus = null
      }
      // this.refreshExercises()
      this.$apollo.queries.exercises.refetch()
    },
    onExerciseFormEdit(payload) {
      // console.log('edit', payload)
      // this.showNotification('Đang xây dựng', 'warning', 'top', 'right', 7000)
      this.$router.push({name: 'exercise_edit', params: {id: payload.id}})
    },
    onExerciseFormDelete(payload) {
      this.$modal.show(popupDeleteExercise, {
        id: payload.id,
        saveFunction: this.onItemDeleteParent
      }, {
        height: 'auto',
        classes: ['col-6'],
        adaptive: true,
        clickToClose: false
      })
    },
    async checkExerciseUsed(exerciseID) {
      if (exerciseID > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_COUNT_EXERCISE_USED),
          variables: {
            where: {exercise_id: {_eq: exerciseID}}
          }
        })
        if (data.result_aggregate && data.result_aggregate.aggregate.count > 0) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    async onItemDeleteParent(payload) {
      // TODO: Đã có người làm bài tập này, không được xóa ? (result model)
      let exerciseUsed = await this.checkExerciseUsed(payload.id)
      // let exerciseUsed = false
      if (!exerciseUsed) {
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_EXERCISE),
          variables: {
            exercise_id: payload.id,
            changes: {
              is_delete: true
            }
          }
        }).then((data) => {
          // Result
          this.$apollo.queries.exercises.refetch()
          // this.refreshExercises()
          this.showNotification('Bài tập đã bị xóa', 'success', 'top', 'right', 7000)
        }).catch((error) => {
          // Error
          console.error(error)
        })
      } else {
        this.showNotification('Bài tập đang được sử dụng, không được xóa', 'danger', 'top', 'right', 7000)
      }
    },
    lockAssistantItem(payload) {
      if (payload.type === 1) {
        if (this.exercises.length > 0) {
          this.$modal.show(popupLockExercise, {
            title: 'MỞ KHOÁ CHỈNH SỬA BÀI TẬP',
            content: 'Bạn có muốn mở khoá chỉnh sửa tất cả bài tập hiện có không? Khi này bạn và các trợ lý sẽ có quyền chỉnh sửa nội dung bài tập.',
            type: payload.type,
            saveFunction: this.lockAllAssistantEdit
          }, {
            height: 'auto',
            classes: ['col-6'],
            adaptive: true,
            clickToClose: false
          })
        }
      } else if (payload.type === 2) {
        if (this.exercises.length > 0) {
          this.$modal.show(popupLockExercise, {
            title: 'KHOÁ CHỈNH SỬA BÀI TẬP',
            content: 'Bạn có muốn khoá chỉnh sửa tất cả bài tập hiện có không? Khi này chỉ có bạn mới có thể chỉnh sửa được nội dung bài tập.',
            type: payload.type,
            saveFunction: this.lockAllAssistantEdit
          }, {
            height: 'auto',
            classes: ['col-6'],
            adaptive: true,
            clickToClose: false
          })
        }
      } else if (payload.type === 3) {
        // console.log(payload)
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_EXERCISE),
          variables: {
            exercise_id: payload.data.id,
            changes: {
              is_lock: true
            }
          },
          update: (store, { data: { update_exercise } }) => {
            // Read the data from our cache for this query.
            try {
              this.$apollo.queries.exercises.refetch()
              // this.refreshExercises()
            } catch (e) {
              console.error(e)
            }
          },
          error(error) {
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
          }
        }).catch((error) => {
          // Error
          console.error(error)
        })
      } else if (payload.type === 4) {
        // console.log(payload)
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_EXERCISE),
          variables: {
            exercise_id: payload.data.id,
            changes: {
              is_lock: false
            }
          },
          update: (store, { data: { update_exercise } }) => {
            // Read the data from our cache for this query.
            try {
              this.$apollo.queries.exercises.refetch()
              // this.refreshExercises()
            } catch (e) {
              console.error(e)
            }
          },
          error(error) {
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
          }
        }).catch((error) => {
          // Error
          console.error(error)
        })
      }
    },
    async lockAllAssistantEdit(payload) {
      if (payload.type === 1) {
        for (let i = 0; i < this.exercises.length; i++) {
          await this.$apollo.mutate({
            mutation: gql(graphql.UPDATE_EXERCISE),
            variables: {
              exercise_id: this.exercises[i].id,
              changes: {
                is_lock: false
              }
            },
            error(error) {
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
            }
          }).catch((error) => {
            // Error
            console.error(error)
          })
        }
        this.$apollo.queries.exercises.refetch()
        // this.refreshExercises()
      } else {
        for (let i = 0; i < this.exercises.length; i++) {
          await this.$apollo.mutate({
            mutation: gql(graphql.UPDATE_EXERCISE),
            variables: {
              exercise_id: this.exercises[i].id,
              changes: {
                is_lock: true
              }
            },
            error(error) {
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
            }
          }).catch((error) => {
            // Error
            console.error(error)
          })
        }
        this.$apollo.queries.exercises.refetch()
        // this.refreshExercises()
      }
    },
    filterItems(id, type) {
      if (type === 1) {
        if (!this.lstFilter.categories.includes(id)) {
          this.lstFilter.categories.push(id)
        } else {
          this.lstFilter.categories.splice(this.lstFilter.categories.indexOf(id), 1)
        }
      } else if (type === 2) {
        if (!this.lstFilter.level.includes(id)) {
          this.lstFilter.level.push(id)
        } else {
          this.lstFilter.level.splice(this.lstFilter.level.indexOf(id), 1)
        }
      } else if (type === 3) {
        if (!this.lstFilter.grades.includes(id)) {
          this.lstFilter.grades.push(id)
        } else {
          this.lstFilter.grades.splice(this.lstFilter.grades.indexOf(id), 1)
        }
      } else if (type === 4) {
        if (!this.lstFilter.type_exercise.includes(id)) {
          this.lstFilter.type_exercise.push(id)
        } else {
          this.lstFilter.type_exercise.splice(this.lstFilter.type_exercise.indexOf(id), 1)
        }
      } else if (type === 5) {
        if (!this.lstFilter.lock.includes(id)) {
          this.lstFilter.lock.push(id)
        } else {
          this.lstFilter.lock.splice(this.lstFilter.lock.indexOf(id), 1)
        }
      } else if (type === 6) {
        this.sort = !this.sort
        this.lstFilter.order_by = this.sort
      }
      // this.refreshExercises()
      this.$apollo.queries.exercises.refetch()
    },
    filterBlue(payload) {
      this.lstFilter.categories = payload.categories
      this.lstFilter.level = payload.level
      this.lstFilter.grades = payload.grades
      this.lstFilter.lock = payload.lock
      this.lstFilter.type_exercise = payload.type_exercise
      this.lstFilter.order_by = payload.order_by
      // this.refreshExercises()
      this.$apollo.queries.exercises.refetch()
    },
    async refreshExercises() {
      // console.log('refreshExercises')
      let objWhere = {
        created_by: {_eq: this.$store.getters.user},
        is_delete: {_eq: false}
      }
      let orderBy = {}
      if (this.filtername !== '') {
        objWhere = Object.assign(objWhere, {name: {_ilike: '%' + this.filtername + '%'}})
      }
      if (this.filtersubject !== null) {
        objWhere = Object.assign(objWhere, {subject_id: {_eq: this.filtersubject}})
      } else {
        this.$delete(objWhere, 'subject_id')
      }
      if (this.filterstatus !== null) {
        objWhere = Object.assign(objWhere, {is_complete: {_eq: this.filterstatus}})
      } else {
        this.$delete(objWhere, 'is_complete')
      }
      if (this.lstFilter.categories.length > 0) {
        objWhere = Object.assign(objWhere, {categ_id: {_in: this.lstFilter.categories}})
      }
      if (this.lstFilter.level.length > 0) {
        objWhere = Object.assign(objWhere, {level: {_in: this.lstFilter.level}})
      }
      if (this.lstFilter.grades.length > 0) {
        objWhere = Object.assign(objWhere, {exercise_grades: {grade_id: {_in: this.lstFilter.grades}}})
      }
      if (this.lstFilter.lock.length > 0) {
        objWhere = Object.assign(objWhere, {is_lock: {_in: this.lstFilter.lock}})
      }
      if (this.lstFilter.type_exercise.length > 0) {
        objWhere = Object.assign(objWhere, {type_test: {_in: this.lstFilter.type_exercise}})
      }
      if (this.lstFilter.order_by) {
        orderBy = Object.assign(orderBy, {name: 'desc'})
      } else {
        orderBy = Object.assign(orderBy, {id: 'desc'})
      }
      let variables = {
        where: objWhere,
        order_by: orderBy,
        limit: this.limit
      }
      // console.log(variables)
      await this.$apollo.query({
        query: gql(graphql.GET_EXERCISES),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((res) => {
        if (res.data.exercise && res.data.exercise.length > 0) {
          this.exercises = res.data.exercise
          for (let i = 0; i < this.exercises.length; i++) {
            this.exercises[i].stt = i + 1
            this.exercises[i].content = '[ID: ' + this.exercises[i].id + '] ' + this.exercises[i].name
          }
          // console.log(this.exercises)
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error.message)
      })
    }
  },
  created() {
    // this.refreshExercises()
  },
  apollo: {
    exercises: {
      query: gql(graphql.GET_EXERCISES),
      fetchPolicy: 'no-cache',
      variables() {
        let objWhere = {
          created_by: {_eq: this.$store.getters.user},
          is_delete: {_eq: false}
        }
        let orderBy = {}
        if (this.filtername !== '') {
          objWhere = Object.assign(objWhere, {name: {_ilike: '%' + this.filtername + '%'}})
        }
        if (this.filtersubject !== null) {
          objWhere = Object.assign(objWhere, {subject_id: {_eq: this.filtersubject}})
        } else {
          // this.$delete(objWhere, 'subject_id')
          this.getSubjectDefalt()
          objWhere = Object.assign(objWhere, {subject_id: {_eq: this.filtersubject}})
        }
        if (this.filterstatus !== null) {
          objWhere = Object.assign(objWhere, {is_complete: {_eq: this.filterstatus}})
        } else {
          this.$delete(objWhere, 'is_complete')
        }
        if (this.lstFilter.categories.length > 0) {
          objWhere = Object.assign(objWhere, {categ_id: {_in: this.lstFilter.categories}})
        }
        if (this.lstFilter.level.length > 0) {
          objWhere = Object.assign(objWhere, {level: {_in: this.lstFilter.level}})
        }
        if (this.lstFilter.grades.length > 0) {
          objWhere = Object.assign(objWhere, {exercise_grades: {grade_id: {_in: this.lstFilter.grades}}})
        }
        if (this.lstFilter.lock.length > 0) {
          objWhere = Object.assign(objWhere, {is_lock: {_in: this.lstFilter.lock}})
        }
        if (this.lstFilter.type_exercise.length > 0) {
          objWhere = Object.assign(objWhere, {type_test: {_in: this.lstFilter.type_exercise}})
        }
        if (this.lstFilter.order_by) {
          orderBy = Object.assign(orderBy, {name: 'asc'})
        } else {
          orderBy = Object.assign(orderBy, {id: 'desc'})
        }
        let variables = {
          where: objWhere,
          order_by: orderBy,
          limit: this.limit
        }
        // console.log(variables)
        return variables
      },
      update: data => {
        for (let i = 0; i < data.exercise.length; i++) {
          data.exercise[i].stt = i + 1
          data.exercise[i].content = '[ID: ' + data.exercise[i].id + '] ' + data.exercise[i].name
        }
        // console.log(data.exercise)
        return data.exercise
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error.message)
      }
    },
    subjects: {
      query: gql(graphql.GET_SUBJECT_USER),
      // fetchPolicy: 'no-cache',
      variables() {
        let variables = {
          where: {
            is_delete: {'_eq': false},
            user_id: {'_eq': this.$store.getters.user},
            status: {'_eq': 2}
          },
          orderBy: {created_at: 'asc'}
        }
        return variables
      },
      update: data => {
        if (data.subject_user.length > 0) {
          let lstSubjects = []
          for (let i = 0; i < data.subject_user.length; i++) {
            lstSubjects.push(data.subject_user[i].subject)
          }
          return lstSubjects
        }
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exercise-content {
  .exercise-body {
    .col-md-header {
      margin-bottom: 0px;
    }
    .header {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      color: #5F6468;
      display: inline-block;
    }
    .box-add-exercise {
      float: right;
      margin-top: -10px;
      .btn-exercise-add {
        background-color: #FFD311;
        width: 214px;
        height: 48px;
        border-radius: 5px;
        color: black;
        text-transform: none;
        font-size: 14px;
        font-family: 'adobe-clean' sans-serif;
        border: 1px solid #FFD311;
        padding: 0;
        margin-bottom: 0;
        &:active {
          background-color: #CCAD7B;
          color: black;
        }
      }
    }
    .select-subject {
      // padding-right: 7.5px;
      .form-group {
        label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
        margin-top: 0;
        input, select {background-color: white;}
      }
    }
    .col-md-lst-exercise {
      // .card-lst-exercise {
      //   border-radius: 10px;
      //   margin-top: 0;
      //   .card-content-lst-exercise {}
      // }
      .box-table-exercise {
        background: white;
        box-shadow: 0px 1px 3px #00000029;
        padding: 10px;
        max-height: 385px; 
        overflow-y: scroll;
        border-radius: 10px;
      }
    }
  }
}
@media (max-width: 414px) {
  .card-lst-exercise {background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; padding: 15px;
    .row-header{border: 1px solid #E0E0E0;border-top: 0;background: #FAFAFA 0% 0% no-repeat padding-box; 
      .label-header{
        .name {width: 50px; line-height: 15px; display: inline-flex; vertical-align: middle; padding: 4px 0;}
        .fa-sort-alpha-down {
          &.checked {color: #219AFF;}
          padding-left: 9px; vertical-align: middle;
        }
        display: inline-block; line-height: 30px;width: 30%;font-weight: bold;text-align: right; padding-right: 10px;
      }
      .field-header{padding: 5px 10px; display: inline-block; width: 70%; background: #EAEAEA 0% 0% no-repeat padding-box;
        input, select{width: 100%;border-radius: 10px; padding: 3px 10px; background: #fff;border: 1px solid #B4B4B4; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;}
      }
      &:first-child{border-top: 1px solid #E0E0E0;border-top-left-radius: 10px;border-top-right-radius: 10px; overflow: hidden;}
      &.last{border-bottom-left-radius: 10px !important;border-bottom-right-radius: 10px !important;overflow: hidden;}
    }
    .list-action-all {
      float: right;
      margin-top: 9px;
      small {
        &:nth-child(2n) {margin-right: 0;}
      }
      small{width: 16px; height: 16px; margin-right: 10px; display: inline-block;
        .fas {cursor: pointer;}
        .fa-user-edit {color: #3A9F00;}
        .fa-user-lock {color: #D63131;}
      }
    }
    .empty-data{margin-top: 20px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; text-align: center; padding: 5px;}
    .list-item{margin-top: 9px;
      .row-item{background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; padding: 7px 5px;margin-bottom: 10px;
        &:first-child{margin-bottom: 10px;}
        &:last-child {margin-bottom: 0;}
        .show-more {
          .row-data {
            .row-value {color: #343A40;}
            &:last-child {
              .row-value {padding-bottom: 0;}
            }
          }
        }
        .row-data{
          .label-header{display: inline-block;text-align: left; padding-right: 8px; color: #969FAD;}
          .row-value{padding-bottom: 8px; display: inline-block;
            &.title{font-size: 15px; font-weight: bold; margin-bottom: 15px;display: block;}
            &.link{text-decoration: underline; color:#554BC1;}
            select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 6px;width: 100%;}
            small{margin-right: 10px; float: left;
              &:last-child{margin-right: 0;}
              img{width: 16px;height: 16px;}
            }
            img.img{border-radius: 50%;width: 30px; height: 30px;}
          }
          .board-info{ width: 100%; display: inline-flex; height: 36px; overflow: hidden; margin-bottom: 8px;
            span{font-size: 15px; font-weight: bold; display: block; color: #9F6A28;}
          }
          .filter-item {
            span {
              padding: 4px 8px; 
              background: #F2F2F2; 
              border-radius: 10px; 
              color: #969FAD; 
              box-shadow: 0px 1px 3px #00000029; 
              margin: 0 8px 8px 0;
              cursor: pointer;
              display: inline-block;
              &.checked {
                background: #219AFF; 
                color: white;
              }
            }
          }
          .action-buttons {
            text-align: right;
            margin-bottom: 8px;
            .list-action {
              small{width: 16px; height: 16px; margin-right: 16px; display: inline-block;
                &.public {margin-right: 8px;}
                img{max-width: 100%; height: auto; cursor: pointer;}
                .fas {cursor: pointer;}
                .ic-public {font-size: 16px;  color: #333333; vertical-align: text-bottom;}
              }
            }
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// index.vue?1e36a8e9